import React from "react";
import { useField, useFormikContext } from "formik";
import { useDispatch, useSelector } from "react-redux";

// material
import {
  Box,
  Container,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
  Typography,
  Stack
} from "@mui/material";

// components
import Page from "../../../components/Page";

// ----------------------------------------------------------------------
import { setUploadFormPhDPage2 } from "../../../core/redux/action/uploadForm";

export default function UploadFormPage1_5year(props) {
  const FORM_2A = "2a";
  const FORM_2AB = "2ab";

  const dispatch = useDispatch();
  const formikProps = useFormikContext();
  const { pagePhd: pageFormRedux } = useSelector(
    (state) => state.uploadFormReducer
  );

  const {
    formField: { yourProgramType, sendingScholarshipReport, semester }
  } = props;

  const [yourProgramTypeField, yourProgramTypeMeta] = useField(yourProgramType);
  const [sendingScholarshipReportField, sendingScholarshipReportMeta] =
    useField(sendingScholarshipReport);
  const [semesterField, semesterMeta] = useField(semester);

  return (
    <Page title="PART: Grade/Progress/Final Report">
      <Container maxWidth="xl">
        <Box sx={{ pb: 5 }}>
          <Typography variant="h4">
            PART: Grade/Progress/Final Report
          </Typography>
        </Box>
        <Stack
          direction="column"
          justifyContent="space-evenly"
          alignItems="stretch"
          spacing={4}
        >
          <FormControl fullWidth>
            <Typography variant="subtitle2">{yourProgramType.label}</Typography>
            <RadioGroup
              name={yourProgramTypeField.name}
              value={yourProgramTypeField.value}
              onChange={(e) => yourProgramTypeField.onChange(e)}
            >
              <FormControlLabel
                value="coursework_with_thesis"
                control={<Radio />}
                label="Coursework with Thesis"
              />
              <FormControlLabel
                value="non_coursework"
                control={<Radio />}
                label="Non-coursework (research only)"
              />
            </RadioGroup>
            {yourProgramTypeMeta.touched && (
              <span
                style={{
                  color: "#FF4842",
                  lineHeight: 1.5,
                  fontSize: "0.75rem",
                  fontFamily: "sans-serif",
                  fontWeight: 400,
                  textAlign: "left",
                  marginTop: "3px",
                  marginRight: "14px",
                  marginBottom: 0,
                  marginLeft: "14px"
                }}
              >
                {yourProgramTypeMeta.error}
              </span>
            )}
          </FormControl>

          <FormControl fullWidth>
            <Typography variant="subtitle2">
              {sendingScholarshipReport.label}
            </Typography>
            <RadioGroup
              name={sendingScholarshipReportField.name}
              value={sendingScholarshipReportField.value}
              onChange={(e) => {
                dispatch(setUploadFormPhDPage2(e.target.value));
                sendingScholarshipReportField.onChange(e);
                formikProps.setFieldValue(semesterField.name, "");
              }}
            >
              <FormControlLabel
                value="2a"
                control={<Radio />}
                label="Semester 1-2 > Fill PART A"
              />
              <FormControlLabel
                value="2ab"
                control={<Radio />}
                label="Semester 3-9 > Fill PART 2A+2B"
              />
              <FormControlLabel
                value="2c"
                control={<Radio />}
                label="Semester 10 > Fill PART 2C"
              />
            </RadioGroup>
            {sendingScholarshipReportMeta.touched && (
              <span
                style={{
                  color: "#FF4842",
                  lineHeight: 1.5,
                  fontSize: "0.75rem",
                  fontFamily: "sans-serif",
                  fontWeight: 400,
                  textAlign: "left",
                  marginTop: "3px",
                  marginRight: "14px",
                  marginBottom: 0,
                  marginLeft: "14px"
                }}
              >
                {sendingScholarshipReportMeta.error}
              </span>
            )}
          </FormControl>

          {pageFormRedux === FORM_2A && (
            <FormControl fullWidth>
              <Typography variant="subtitle2">{semester.label}</Typography>
              <RadioGroup
                name={semesterField.name}
                value={semesterField.value}
                onChange={(e) => semesterField.onChange(e)}
              >
                <FormControlLabel
                  value="semester1"
                  control={<Radio />}
                  label="Semester 1"
                />
                <FormControlLabel
                  value="semester2"
                  control={<Radio />}
                  label="Semester 2"
                />
              </RadioGroup>
              {semesterMeta.touched && (
                <span
                  style={{
                    color: "#FF4842",
                    lineHeight: 1.5,
                    fontSize: "0.75rem",
                    fontFamily: "sans-serif",
                    fontWeight: 400,
                    textAlign: "left",
                    marginTop: "3px",
                    marginRight: "14px",
                    marginBottom: 0,
                    marginLeft: "14px"
                  }}
                >
                  {semesterMeta.error}
                </span>
              )}
            </FormControl>
          )}

          {pageFormRedux === FORM_2AB && (
            <FormControl fullWidth>
              <Typography variant="subtitle2">{semester.label}</Typography>
              <RadioGroup
                name={semesterField.name}
                value={semesterField.value}
                onChange={(e) => semesterField.onChange(e)}
              >
                <FormControlLabel
                  value="semester3"
                  control={<Radio />}
                  label="Semester 3 (Year2)"
                />
                <FormControlLabel
                  value="semester4"
                  control={<Radio />}
                  label="Semester 4"
                />
                <FormControlLabel
                  value="semester5"
                  control={<Radio />}
                  label="Semester 5 (Year3)"
                />
                <FormControlLabel
                  value="semester6"
                  control={<Radio />}
                  label="Semester 6"
                />
                <FormControlLabel
                  value="semester7"
                  control={<Radio />}
                  label="Semester 7 (Year4)"
                />
                <FormControlLabel
                  value="semester8"
                  control={<Radio />}
                  label="Semester 8"
                />
                <FormControlLabel
                  value="semester9"
                  control={<Radio />}
                  label="Semester 9 (Year5)"
                />
              </RadioGroup>
              {semesterMeta.touched && (
                <span
                  style={{
                    color: "#FF4842",
                    lineHeight: 1.5,
                    fontSize: "0.75rem",
                    fontFamily: "sans-serif",
                    fontWeight: 400,
                    textAlign: "left",
                    marginTop: "3px",
                    marginRight: "14px",
                    marginBottom: 0,
                    marginLeft: "14px"
                  }}
                >
                  {semesterMeta.error}
                </span>
              )}
            </FormControl>
          )}
        </Stack>
      </Container>
    </Page>
  );
}
